import { createFirebaseBrowserAuth } from '@london-life/auth-client';
import { env } from './env';

// Firebase handles the sign-in screens' identity part; our API issues the session afterwards
export const browserAuth = createFirebaseBrowserAuth({
  apiKey: env.firebase.apiKey,
  authDomain: env.firebase.authDomain,
  projectId: env.firebase.projectId,
  appId: env.firebase.appId,
});
